const options = {
  style: {
    base: {
      color: '#5D5D5D',
      fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      // SR red-pomegranate
      color: '#EA321B',
      iconColor: '#EA321B',
    },
  },
  classes: {
    base: 'stripe-form__card-element',
    complete: 'stripe-form__card-element--complete',
    empty: 'stripe-form__card-element--empty',
    focus: 'stripe-form__card-element--focus',
    invalid: 'stripe-form__card-element--invalid',
    webkitAutofill: 'stripe-form__card-element--webkit-autofill',
  },
};

export default options;
